module.exports = __webpack_public_path__ + "img/banner-pricing.47edc668.webp";